import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UpgradeModule } from '@angular/upgrade/static';
import { AccountsDomainModule } from '@mode/accounts/domain';
import { ChartsDomainModule } from '@mode/charts/domain';
import { ChartsFeatureEncodingModule } from '@mode/charts/feature-encoding';
import { CollectionsFeatureManageAccessModule } from '@mode/collections/feature-manage-access';
import { ExplorationsShellModule } from '@mode/explorations/shell';
import { FileExportsDomainModule } from '@mode/file-exports/domain';
import { GithubFeatureSyncModalModule } from '@mode/github/feature-sync-modal';
import { MetricsDomainModule } from '@mode/metrics/domain';
import { ReportEditorDomainModule } from '@mode/report-editor/domain';
import { ReportViewerDomainModule } from '@mode/report-viewer/domain';
import { PdfExportDomainModule } from '@mode/report-viewer/pdf-export/domain';
import { ReportViewerShellModule as ReportViewerShellAngular2Module } from '@mode/report-viewer/shell';
import { ReportsDomainModule } from '@mode/reports/domain';
import { SharedDataAccessFlamingoModule } from '@mode/shared/data-access-flamingo';
import { SharedDataAccessWebappModule } from '@mode/shared/data-access-webapp';
import { EmptyComponent } from '@mode/shared/ui';
import { SharedUtilDomModule } from '@mode/shared/util-js';
import { SwitchViewsFeatureFieldlistModule } from '@mode/switch-views/feature-fieldlist';
import { EffectsModule } from '@ngrx/effects';
import { PlatformHeaderNavPanelComponentModule } from '~/components/platform-header-nav-panel/platform-header-nav-panel-component.module';
import { LegacyBootstrapService, mark } from '~/legacy-bootstrap.service';
import { LEGACY_PROVIDERS } from '~/lib/legacy-providers';
import { LEGACY_STORES } from '~/lib/legacy-reducers';
import { loadReportViewerAngularJsAppShell } from '.';
import { ReportRpcErrorEffects } from './services/report-rpc-error.effects';
import { SharedSchedulesFeatureScheduleEditorModule } from '@mode/shared/schedules/feature-schedule-editor';

const enableRouterTracing = false;

/**
 * If you want to enable ui-router tracing.
 * Importing trace will add ui-router to the bundle.
 * So it is commented out by default.
 */
// import { trace } from '@uirouter/core';
// trace.enable();

@NgModule({
  imports: [
    CommonModule,
    ChartsDomainModule,
    ChartsFeatureEncodingModule,
    FileExportsDomainModule,
    GithubFeatureSyncModalModule, // Including this because of Platform Header :(
    MetricsDomainModule, // Including this because of Platform Header :(
    SharedDataAccessFlamingoModule,
    SharedDataAccessWebappModule,
    SharedUtilDomModule,
    UpgradeModule,
    ReportEditorDomainModule, // Yes, we actually need this. Oops, bad boundaries.
    ReportViewerShellAngular2Module,
    ExplorationsShellModule,
    ReportViewerDomainModule,
    ReportsDomainModule,
    PdfExportDomainModule,
    AccountsDomainModule,
    ReactiveFormsModule,
    SwitchViewsFeatureFieldlistModule,
    CollectionsFeatureManageAccessModule,
    PlatformHeaderNavPanelComponentModule,
    SharedSchedulesFeatureScheduleEditorModule,
    EffectsModule.forFeature([ReportRpcErrorEffects]),
    RouterModule.forChild([
      {
        path: '**',
        component: EmptyComponent,
      },
    ]),
    ...LEGACY_STORES,
  ],
  providers: [...LEGACY_PROVIDERS],
})
export class ReportViewerShellModule {
  constructor(
    private upgrade: UpgradeModule,
    private legacy: LegacyBootstrapService,
    private injector: Injector
  ) {
    this.legacy.bootstrap(loadAngularJsApp, this.upgrade, this.injector);
  }
}

async function loadAngularJsApp() {
  mark('report-view-shell.js', 'mode.webapp_ui.resource.js.report-view-shell');
  // Attach downgraded components
  loadReportViewerAngularJsAppShell();
}
